export default __webpack_public_path__ + "static/media/logo1.123013d9.jpg";